__turbopack_context__.v({
  "copyright": "Footer-module-scss-module__kQc2fa__copyright",
  "dir-grid": "Footer-module-scss-module__kQc2fa__dir-grid",
  "directory": "Footer-module-scss-module__kQc2fa__directory",
  "footer": "Footer-module-scss-module__kQc2fa__footer",
  "tagline": "Footer-module-scss-module__kQc2fa__tagline",
});
